import React, { Component } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import Cbutton from "../../components/button";
import SERVICE from "../../rest-api/api-call.js";
import Modal from "react-bootstrap/Modal";

export default class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      discribe: "",
      fullName: "",
      email: "",
      phoneNumber: "",
      website: "",
      validForm: false,
      show: false,
      inValidEmail: false,
      validPhone: false,
      discribtionLength: false,
    };
  }

  handleUserInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  }

  handleClose = () => {
    this.setState({
      show: false,
    });
  };

  handleShow = () => {
    this.setState({
      show: true,
    });
  };

  //   async handleClick() {
  //     // e.preventDefault();
  //     var payload = {
  //       project_description: this.state.discribe,
  //       name: this.state.fullName,
  //       email: this.state.email,
  //       phone_number: this.state.phoneNumber,
  //       website: this.state.website,
  //       budget: this.props.budget,
  //       specifications: localStorage.getItem("specifications"),
  //       services: localStorage.getItem("list"),
  //     };
  //     console.log("000000000000000", payload);
  //     if (payload.phone_number.length > 10 && payload.phone_number.length <= 12) {
  //       this.setState({ validPhone: false });
  //     } else {
  //       this.setState({ validPhone: true });
  //     }
  //     if (
  //       payload.project_description == "" ||
  //       payload.project_description.length >= 50 ||
  //       payload.name == "" ||
  //       payload.email == "" ||
  //       payload.phone_number == "" ||
  //       payload.website == "" ||
  //       !this.state.validPhone ||
  //       !/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(payload.email)
  //     ) {
  //       this.setState({ validForm: true });
  //       if (payload.project_description.length >= 50) {
  //         this.setState({ discribtionLength: false });
  //       } else {
  //         this.setState({ discribtionLength: true });
  //       }
  //       if (!/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(payload.email)) {
  //         this.setState({
  //           inValidEmail: true,
  //         });
  //       } else {
  //         this.setState({
  //           inValidEmail: false,
  //         });
  //       }
  //       return false;
  //     }
  //     // SERVICE._GetEstimated(payload).then(res =>{
  //     //     this.handleShow()
  //     //     this.setState({
  //     // discribe: '',
  //     // fullName: '',
  //     // email: '',
  //     // phoneNumber: '',
  //     // website: '',
  //     // validForm: false,
  //     // validPhone : false
  //     //     })
  //     // }).catch(e => { });
  //     fetch("/api/getestimae", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     })
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if (data.success) {
  //           this.handleShow();

  //           this.setState({
  //             discribe: "",
  //             fullName: "",
  //             email: "",
  //             phoneNumber: "",
  //             website: "",
  //             specifications: "",
  //             services: "",
  //             budget: "",
  //             validForm: false,
  //             validPhone: false,
  //           });
  //         } else {
  //           this.setState({ serverError: data.error });
  //         }
  //       })
  //       .catch(() => this.setState({ serverError: "Network error" }));
  //   }

  handleClick = async (e) => {
    e.preventDefault(); // Prevent form submission reload
    if (this.state.isSubmitting) return;
    const payload = {
      project_description: this.state.discribe,
      name: this.state.fullName,
      email: this.state.email,
      phone_number: this.state.phoneNumber,
      website: this.state.website,
      budget: this.props.budget,
      specifications: localStorage.getItem("specifications") || "",
      services: localStorage.getItem("list") || "",
    };

    // Phone validation
    if (payload.phone_number.length >= 10 && payload.phone_number.length <= 12) {
      this.setState({ validPhone: false });
    } else {
      this.setState({ validPhone: true });
    }

    // Email validation
    const emailValid = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(
      payload.email
    );
    this.setState({ inValidEmail: !emailValid });

    // Description validation (min 50 characters)
    const discribeValid = payload.project_description.length >= 50;
    this.setState({ discribtionLength: !discribeValid });

    // Check overall form validity
    if (
      !payload.name ||
      !payload.email ||
      !payload.phone_number ||
      !payload.website ||
      !discribeValid ||
      !emailValid ||
      this.state.validPhone
    ) {
      this.setState({ validForm: true });
      return false;
    }
    this.setState({ isSubmitting: true });
    // Submit to backend
    try {
      const res = await fetch("/api/getestimate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.success) {
        this.handleShow();
        // Reset form
        this.setState({
          discribe: "",
          fullName: "",
          email: "",
          phoneNumber: "",
          website: "",
          validForm: false,
          validPhone: false,
          inValidEmail: false,
          discribtionLength: false,
          serverError: "",
        });
      } else {
        this.setState({
          serverError: data.error || "Something went wrong",
          isSubmitting: false,
        });
      }
    } catch (err) {
      this.setState({ serverError: "Network error", isSubmitting: false });
    }
  };

  render() {
    let {
      discribe,
      fullName,
      email,
      phoneNumber,
      website,
      validForm,
      show,
      inValidEmail,
      validPhone,
      discribtionLength,
    } = this.state;
    return (
      <div>
        <Form onSubmit={this.handleClick}>
          <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Label className="case-study-heading">
              Describe your project
            </Form.Label>
            <br />
            <Form.Label className="">
              Text lenght : {discribe.length}{" "}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows="8"
              className={
                ((validForm && discribe == "") || discribtionLength) &&
                "error-msg-b"
              }
              value={discribe}
              name="discribe"
              onChange={(event) => this.handleUserInput(event)}
            />
            {((validForm && discribe == "") || discribtionLength) && (
              <span className="error-msg">
                Please explain your project in not less than 50 words.
              </span>
            )}
          </Form.Group>
          <Row>
            <Col className="pr-sm-0 pt-4" md>
              <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Label className="case-study-heading">
                  Full Name
                </Form.Label>
                <Form.Control
                  type="text"
                  className={validForm && fullName == "" && "error-msg-b"}
                  value={fullName}
                  name="fullName"
                  onChange={(event) => this.handleUserInput(event)}
                />
                {validForm && fullName == "" && (
                  <span className="error-msg">
                    Please enter a valid full name
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md className="pt-4">
              <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Label className="case-study-heading">
                  Email Address
                </Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  className={
                    ((validForm && email == "") || inValidEmail) &&
                    "error-msg-b"
                  }
                  name="email"
                  onChange={(event) => this.handleUserInput(event)}
                />
                {((validForm && email == "") || inValidEmail) && (
                  <span className="error-msg">Please enter a valid email</span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col className="pr-sm-0" md>
              <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Label className="case-study-heading">
                  Phone Number
                </Form.Label>
                <Form.Control
                  type="text"
                  className={
                    ((validForm && phoneNumber == "") || validPhone) &&
                    "error-msg-b"
                  }
                  value={phoneNumber}
                  name="phoneNumber"
                  onChange={(event) => this.handleUserInput(event)}
                />
                {((validForm && phoneNumber == "") || validPhone) && (
                  <span className="error-msg">
                    Please enter a valid phone number with country code
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md>
              <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Label className="case-study-heading mobile-let-chat">
                  Website
                </Form.Label>
                <Form.Control
                  type="text"
                  className={validForm && website == "" && "error-msg-b"}
                  value={website}
                  name="website"
                  onChange={(event) => this.handleUserInput(event)}
                />
                {validForm && website == "" && (
                  <span className="error-msg">
                    Please enter a valid website
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
          {/* {serverError && <p className="error-msg mt-2">{serverError}</p>} */}

          {/* Submit Button */}
          {/* <div className="mt-4">
            <Cbutton type="submit" name="Get estimate aaaaaaa" extra />
          </div>     */}
        </Form>
        <section>
          <Modal show={show} onHide={this.handleClose.bind(this)}>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body className="text-center">
              <div className="text-center pb-2">
                <svg
                  class="checkmark check-scss"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  <circle
                    class="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    class="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
              </div>
              <div className="spectial-content pt-5 pb-3">
                We received your information!. <br /> Our expert team will get
                back to you soon.
              </div>
            </Modal.Body>
          </Modal>
        </section>
        <div className="">
          {/* <div className="hghf000" onClick={this.handleClick.bind(this)}>
            <Cbutton type="submit" name="Get estimate" extra={true} />
          </div> */}
          
          <div
            className="hghf000"
            onClick={(event) =>
              !this.state.isSubmitting && this.handleClick(event)
            }
            style={{
              pointerEvents: this.state.isSubmitting ? "none" : "auto",
            }}
          >
            <Cbutton
              name={this.state.isSubmitting ? "Submitting..." : "Submit"}
              extra={true}
            />
          </div>
        </div>
      </div>
    );
  }
}
